import { BASE_URL } from "../utils/variables";
import { getAuthHeaders } from "./authentication";

const baseURL = BASE_URL;

export const fetchRolesWithoutAdmin = async (): Promise<any> => {
    const url = `${baseURL}/nonMaster`;

    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
}